import { createContext, useContext } from 'react';
import type { CandidateStoryRequestItem } from 'types/candidateStories';

export type CandidateStoryFormContextValue = {
  chargeSelectionEnabled: boolean;
  requestedItems?: CandidateStoryRequestItem[];
};

export const CandidateStoryFormContext =
  createContext<CandidateStoryFormContextValue>({
    chargeSelectionEnabled: true,
    requestedItems: [],
  });

export const useCandidateStoryFormContext = () =>
  useContext(CandidateStoryFormContext);
